// extracted by mini-css-extract-plugin
export default {"root":"DeleteReport_root__IeSMJ","btn":"DeleteReport_btn__FV98z","description":"DeleteReport_description__aDwD1","wrapperBtn":"DeleteReport_wrapperBtn__GcVSH"};